import { render, staticRenderFns } from "./CharityAdminUsers.vue?vue&type=template&id=4d06d3a2&"
import script from "./CharityAdminUsers.vue?vue&type=script&lang=js&"
export * from "./CharityAdminUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports